import LegalPage, { LegalSection } from "@/components/site/LegalPage";

export default function DataDeletion() {
  return (
    <LegalPage
      title="Ștergerea Datelor"
      eyebrow="Protecția datelor"
      subtitle="Instrucțiuni privind ștergerea datelor asociate utilizării aplicației AutoRIO și integrării cu Facebook."
      seoDesc="Ștergere date AutoRIO — instrucțiuni pentru solicitarea ștergerii datelor asociate aplicației și integrării cu Facebook. Contact protecția datelor."
      path="/stergere-date"
    >
      <LegalSection title="Dreptul la protecția datelor">
        <p>
          AutoRIO respectă dreptul utilizatorilor la protecția datelor cu
          caracter personal.
        </p>
        <p>
          Aplicația AutoRIO utilizată pentru integrarea cu Facebook nu
          stochează date personale ale utilizatorilor Facebook în propriile
          baze de date și nu colectează informații personale prin intermediul
          autentificării Facebook.
        </p>
      </LegalSection>

      <LegalSection title="Cum soliciți ștergerea datelor">
        <p>
          Dacă doriți să solicitați ștergerea oricăror date asociate utilizării
          aplicației sau aveți întrebări privind protecția datelor, ne puteți
          contacta folosind datele de mai jos:
        </p>
        <p>
          Email:{" "}
          <a
            href="mailto:autoriosv@yahoo.com"
            className="text-[#D4AF37] font-semibold hover:underline"
            data-testid="data-deletion-email"
          >
            autoriosv@yahoo.com
          </a>
        </p>
        <p>
          După primirea solicitării, aceasta va fi analizată și soluționată în
          conformitate cu legislația aplicabilă privind protecția datelor.
        </p>
      </LegalSection>

      <LegalSection title="Informații suplimentare">
        <p>
          Pentru informații suplimentare despre modul în care prelucrăm datele,
          consultați pagina{" "}
          <a
            href="/politica-confidentialitate"
            className="text-[#D4AF37] font-semibold hover:underline"
          >
            Politica de Confidențialitate
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
